import { ConfigItem } from 'Core/interfaces'

import { TaxRate } from './TaxCategory'

export enum SearchResultFields {
	searchById = 'searchById',
	searchByCode = 'searchByCode',
	searchByName = 'searchByName'
}
export declare namespace Country {
	interface Basic extends NameCode {
		id: number
	}

	interface Detailed extends NameCode {
		taxRates: TaxRate.Detailed[]
	}

	namespace Search {
		interface Result {
			[SearchResultFields.searchById]: Country.Basic[]
			[SearchResultFields.searchByName]: Country.Basic[]
			[SearchResultFields.searchByCode]: Country.Basic[]
		}
		interface Config {
			[SearchResultFields.searchById]: ConfigItem<SearchResultFields>
			[SearchResultFields.searchByName]: ConfigItem<SearchResultFields>
			[SearchResultFields.searchByCode]: ConfigItem<SearchResultFields>
		}
	}

	namespace Form {
		interface Generic extends NameCode {
			taxRates: TaxRate.Form.Generic[]
		}
	}

	namespace Request {
		interface Generic extends NameCode {
			taxRates: TaxRate.Request.Generic[]
		}
	}
}
